import { render, staticRenderFns } from "./SfGallery.vue?vue&type=template&id=00e08999&scoped=true&"
import script from "./SfGallery.vue?vue&type=script&lang=js&"
export * from "./SfGallery.vue?vue&type=script&lang=js&"
import style0 from "./SfGallery.vue?vue&type=style&index=0&id=00e08999&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e08999",
  null
  
)

export default component.exports